import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar";

export default function Layout() {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  // Close the drawer whenever navigation happens (mobile expectation).
  useEffect(() => { setNavOpen(false); }, [location.pathname]);

  return (
    <div className="min-h-screen flex bg-zinc-50">
      {navOpen && (
        <div
          className="fixed inset-0 z-30 bg-zinc-950/40 lg:hidden"
          onClick={() => setNavOpen(false)}
          data-testid="nav-backdrop"
        />
      )}
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <div className="lg:hidden flex items-center gap-2 border-b border-zinc-200 bg-white px-4 py-3">
          <button
            onClick={() => setNavOpen(true)}
            className="p-1.5 -ml-1.5 rounded-md text-zinc-700 hover:bg-zinc-100"
            aria-label="Menu"
            data-testid="mobile-nav-toggle"
          >
            <Menu size={20} />
          </button>
          <div className="font-heading text-lg font-bold tracking-tighter text-zinc-950">Cornerstone</div>
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-cs-accent" />
        </div>
        <Outlet />
      </main>
    </div>
  );
}
